import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {pcversion, pcversions} = api



/**
 * 查找
 */
export async function findPcversion(params) {
    return request({url: pcversion, method: 'get', data: params,})
}

/**
 * 创建
 */
export async function createPcversion(params) {
    return request({url: pcversions, method: 'post', data: params,})
}

/**
 * 更新
 */
export async function updatePcversion(params) {
    return request({url: pcversion, method: 'put', data: params,})
}

/**
 * 删除
 */
export async function deletePcversion(params) {
    return request({url: pcversion, method: 'delete', data: params,})
}


/**
 * 查找列表
 */
export async function findPcversions(params) {
    return request({url: pcversions, method: 'get', data: params,})
}

/**
 * 删除
 */
export async function deletePcversions(params) {
    return request({url: pcversions, method: 'delete', data: params,})
}



// WEBPACK FOOTER //
// ./src/services/pc-version.js